import styled, { css } from 'styled-components';
import { focusVisibleMixin } from '@elfsight/widget-ui';
import type { PairType } from '../../../types';
import { PairSlider } from './PairSlider';

interface PairProps {
  viewWidth: number;
  viewHeight: number;
  captionFontSize: number;
  compact: boolean;
  withCaptionMagicMargins: boolean;
  data: PairType;
  captionColor?: string;
}

export function Pair({
  viewWidth,
  viewHeight,
  captionFontSize,
  compact,
  withCaptionMagicMargins,
  captionColor,
  data,
  ...props
}: PairProps) {
  const { caption: captionText } = data || {};

  return (
    <Container _elementWidth={viewWidth}>
      <PairSlider
        {...props}
        viewWidth={viewWidth}
        viewHeight={viewHeight}
        compact={compact}
        data={data}
      />

      {captionText && (
        <Caption
          dangerouslySetInnerHTML={{ __html: captionText }}
          _elementFontSize={captionFontSize}
          _elementColor={captionColor}
          _compact={compact}
          _withCaptionMagicMargins={withCaptionMagicMargins}
        />
      )}
    </Container>
  );
}

const Container = styled.div<{
  _elementWidth: number;
}>`
  ${({ _elementWidth: width }) => css({ width })};
`;

const Caption = styled.div<{
  _compact: boolean;
  _withCaptionMagicMargins: boolean;
  _elementFontSize: number;
  _elementColor?: string;
}>`
  text-align: center;
  line-height: 1.38;
  word-break: break-word;

  ${({ _compact, _withCaptionMagicMargins }) => css`
    margin-top: ${!_withCaptionMagicMargins || !_compact ? 6 : 36}px;
  `};

  ${({ _compact, _withCaptionMagicMargins }) =>
    _withCaptionMagicMargins &&
    !_compact &&
    css`
      margin-left: 100px;
      margin-right: 100px;
    `};

  ${({ _elementFontSize, _elementColor }) =>
    css({
      fontSize: _elementFontSize,
      color: _elementColor
    })};

  & a {
    color: inherit;
    ${focusVisibleMixin}
  }
`;
